/*
 * Base class for all PDP hero media wrapper types
 */
var HeroMediaBase = (function ($) {
    var selectors = {
        utilities: '.js-pdp-hero-utilities'
    },
        imgCount = 0;
    var heroMediaBase = function ($container, $mediaElement) {
        /// <summary>
        /// Constructor for HeroMediaBase objects
        /// </summary>
        /// <param name="$container" type="JQueryObject">The jquery wrapper of the hero image container div</param>
        /// <param name="$mediaElement" type="JQueryObject">The jquery wrapper of the hero image/iframe element</param>

        var that = this;

        //save the image object into data for later use
        $mediaElement.data('hero-media', that);

        that.$alternateImage = $('<span class="pdp-hero-alt-thumb-wrap"></span>')
            .append('<img class="pdp-hero-alt-thumb pdp-selector" alt="Product image ' + ++imgCount + '" />');
        that.$container = $container;
        that.displayUtilities = true;
        that.$dot = $('<span class="pdp-alt-dot"></span>');

        that.$alternateImage.find('img').attr('alt', $mediaElement.attr('alt'));
        that.$alternateImage.add(that.$dot)
            .addClass($mediaElement.attr('class').replace('pdp-hero-image', ''))
            .click(function () {
                //Only perform the select if this element is not already active
                if (!$(this).hasClass('active')) {
                    that.select();
                }
            });
        that.$mediaElement = $mediaElement;
    };

    heroMediaBase.prototype.select = function () {
        /// <summary>
        /// Selects this hero media by activating all of its elements and
        /// deselecting other elements not belonging to this hero
        /// </summary>
        var that = this;

        that.$alternateImage.add(that.$dot).add(that.$mediaElement)
            .addClass('active')
            .siblings('.active').removeClass('active')
            //if there is an active video, turn it off by removing the src attribute
            .filter('iframe[src]').removeAttr('src');
        that.$container.find(selectors.utilities).toggleClass('invisible', !that.displayUtilities);
    };

    return heroMediaBase;
}(jQuery));